// WARNING OVERRIDE
// const API_ENDPOINT = 'http://localhost:3000/';
const API_ENDPOINT = 'https://ist-mri-numris-api.azurewebsites.net/';

export default API_ENDPOINT;
